<div class="bi-dashboard-container">
  <div class="bi-dashboard-header">
    <h1 class="bi-dashboard-title">{{biDashboardConstants.title}}</h1>
    <div class="bi-dashboard-options">
      <div class="category">
        <span>{{biDashboardConstants.category}}</span>
        <thera-dropdown [autoSelectByDefault]="false" [defaultSelection]="selectedCategory" [options]="categoryOptions" (optionSelected)="onCategoryChange($event)" [required]="true"></thera-dropdown>
      </div>
      <div class="dashboard">
        <span>{{biDashboardConstants.dashboard}}</span>
        <div class="dashboard-section">
          <thera-dropdown *ngIf="dashboardOptions.length; else noOptions" [autoSelectByDefault]="dashboardAutoSelectByDefault" [defaultSelection]="selectedDashboard" [options]="dashboardOptions" (optionSelected)="onDashboardChange($event)"  [isDisabled]="disableDashboard"></thera-dropdown>
          <span class="no-dashboards" *ngIf="isCategorySelected && !dashboardOptions.length">{{biDashboardConstants.noDashboardsAvailable}}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="bi-dashboard-content" #biDashboardMountPoint></div>
</div>

<ng-template #noOptions>
<thera-dropdown
[isDisabled]="true"
>
</thera-dropdown>
</ng-template>
